function page (path) {
  const pages = import.meta.glob('../pages/**')
  return pages[`../pages/${path}`]
}

export default [
  // Logged Users
  { path: '/home', name: 'home', component: page('home.vue') },
  { path: '/register', name: 'register', component: page('register.vue') },
  { path: '/daily-dashboard/:date?', name: 'daily-dashboard', component: page('daily-dashboard.vue') },


  { path: '/settings', name: 'settings', component: page('settings/index.vue'), meta: { backgroundColor: 'bg-moone-purple-30' }},
  { path: '/settings/profile', name: 'settings-profile', component: page('settings/profile.vue') },
  { path: '/settings/food/restrictions', name: 'settings-food-restrictions', component: page('settings/food-restrictions.vue') },
  { path: '/settings/goals', name: 'settings-goals', component: page('settings/goals.vue') },
  { path: '/settings/notifications', name: 'settings-notifications', component: page('settings/notifications-preferences.vue') },
  { path: '/settings/account', name: 'settings-account', component: page('settings/account.vue') },
  { path: '/settings/contraception', name: 'settings-contraception-type', component: page('settings/contraception-type.vue') },
  { path: '/settings/pill-schedule', name: 'settings-pill-schedule', component: page('settings/pill-schedule.vue') },
  { path: '/language/select', name: 'language-select', component: page('settings/language-select.vue') },
  { path: '/pricing', name: 'pricing', component: page('pricing.vue') },
  { path: '/settings/admin', name: 'settings-admin', component: page('settings/admin.vue') },
  { path: '/settings/health-conditions', name: 'settings-health-conditions', component: page('settings/health-conditions.vue') },
  { path: '/faqs', name: 'faqs', component: page('settings/Faq.vue') },
  { path: '/rgpd', name: 'rgpd', component: page('legal-help/rgpd.vue') },
  { path: '/cgv', name: 'cgv', component: page('legal-help/cgv.vue') },



  { path: '/analysis', name: 'analysis', component: page('analysis/index.vue') },
  { path: '/habit-tracker/:date?', name: 'habit-tracker', component: page('habitTracker.vue'), meta: { backgroundColor: 'bg-moone-purple-30' } },
  { path: '/habit-edit/:date?', name: 'habit-edit', component: page('habitEdit.vue') },
  { path: '/habit-tracker-report/view', name: 'habit-tracker-report-view', component: page('ViewHabitTrackerReport.vue') },
  { path: '/subscriptions', name: 'subscriptions', component: page('subscription-portal.vue') },
  { path: '/settings/subscriptions', name: 'settings-subscriptions', component: page('settings/subscriptions.vue') },
  { path: '/add-period', name: 'add-period', component: page('period-log-form.vue') },
  { path: '/period', name: 'period', component: page('period.vue') },
  { path: '/cycle-education', name: 'cycle-education', component: page('cycle-education.vue') },
  { path: '/lifestyle-recommendations', name: 'lifestyle-recommendations', component: page('lifestyle-recommendations.vue') },
  { path: '/doctor-visit-summary/generate', name: 'doctor-visit-summary-generate', component: page('GenerateDoctorVisitSummary.vue') },
  { path: '/doctor-visit-summary/view', name: 'doctor-visit-summary-view', component: page('ViewDoctorVisitSummary.vue') },
  { path: '/report', name: 'report', component: page('analysis/report.vue') },
  { path: '/onboarding/free-trial', name: 'free-trial', component: page('FreeTrialStep.vue'), meta: { backgroundColor: 'bg-moone-pink' }},
  { path: '/onboarding/subscription', name: 'subscription-selection', component: page('subscription-selection.vue'), meta: { backgroundColor: 'bg-moone-pink' }},

  { path: '/onboarding/nutrition', name: 'onboarding-nutrition', component: page('onboarding/nutrition.vue') },
  { path: '/onboarding/period', name: 'onboarding-period', component: page('onboarding/period.vue') },

  // Guest Routes
  { path: '/', name: 'get-started', component: page('get-started.vue') },
  { path: '/home', name: 'welcome', redirect: { name: 'home' } },
  { path: '/onboarding/form', name: 'onboarding-form', component: page('onboarding/onboarding-form.vue') },
  { path: '/onboarding', name: 'onboarding', component: page('onboarding.vue') },
  { path: '/login', name: 'login', component: page('login.vue') },
  { path: '/signin', name: 'signin', component: page('auth/signin.vue') },

  { path: '*', component: page('errors/404.vue') }
]
